import React from 'react';
import { bonuses } from '../../data/landing';
import { LazyImage } from '../LazyImage';
import { Countdown } from '../Countdown';
import type { Bonus } from '../../types/landing';
import { useMarquee } from '../../hooks/useMarquee';
export function BonusSection() {
  const trackRef = useMarquee<HTMLUListElement>(40);
  return <section id="bonos" className="overflow-hidden bg-petrol-900 py-10 text-cream sm:py-20" data-id="element-125" data-mp="2yr17bsw2lah3">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-126" data-mp="3mhep8qkxxsxy">
        <div className="text-center" data-id="element-127" data-mp="3rex0inmfkk94">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-gold-400" data-id="element-128" data-mp="3rdvfbqbpahdo">
            Solo <span className="rounded bg-terra-500 px-1.5 py-0.5 text-cream" data-id="element-129" data-mp="3cpir5fiuu2tq">HOY</span> con tu compra
          </p>
          <h2 className="mt-3 font-serif text-[2.4rem] leading-none sm:mt-4 sm:text-6xl" data-id="element-130" data-mp="3hnsonws1xfii">
            <span className="text-gold-300" data-id="element-131" data-mp="98s6pvmizn8i">5</span> bonos de regalo
          </h2>
          <div className="mt-5 flex flex-col items-center gap-2.5 sm:mt-7" data-id="element-132" data-mp="e1buflexfyr1">
            <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-petrol-100" data-id="element-133" data-mp="38016125i321e">Los bonos se van en:</p>
            <Countdown data-id="element-134" data-mp="33295xkupc9m4" />
          </div>
        </div>
      </div>

      {/* Calesita: la lista se duplica para que el desplazamiento sea continuo */}
      <div className="mt-7 overflow-hidden sm:mt-12" aria-label="Bonos de regalo" data-id="element-135" data-mp="3hrx80oapjcaw">
        <ul ref={trackRef} className="flex w-max will-change-transform" data-id="element-136" data-mp="3cy2slx24xjhm">
          {bonuses.map(b => <BonusCard key={b.number} bonus={b} data-id="element-137" data-mp="3qsvct8syznuj" />)}
          {bonuses.map(b => <BonusCard key={`dup-${b.number}`} bonus={b} hidden data-id="element-138" data-mp="3lts85pgwjjn3" />)}
        </ul>
      </div>

      <p className="mx-auto mt-7 max-w-2xl px-5 text-center font-serif text-lg leading-snug sm:mt-10 sm:text-3xl" data-id="element-139" data-mp="4hhoouod1gld">
        5 recursos extra para sumar <span className="text-terra-300" data-id="element-140" data-mp="26afesiqr5v2m">todavía más herramientas</span> a tu práctica.
      </p>
    </section>;
}
function BonusCard({
  bonus: b,
  hidden = false
}: {
  bonus: Bonus;
  hidden?: boolean;
}) {
  return <li aria-hidden={hidden || undefined} className="group w-[230px] shrink-0 pr-3 sm:w-[280px] sm:pr-5" data-id="element-141" data-mp="2r11dc8kt6kkr">
      <div className="flex h-full flex-col rounded-2xl bg-petrol-800 p-3" data-id="element-142" data-mp="2v2curqtj3zhv">
        <div className="flex aspect-square items-center justify-center overflow-hidden rounded-xl bg-cream p-3" data-id="element-143" data-mp="300epxa48bp9p">
          <LazyImage src={b.image} alt={hidden ? '' : `Bono ${b.number}: ${b.title}`} width={b.imageWidth} height={b.imageHeight} sizes="280px" className="h-full w-full object-contain mix-blend-multiply transition-transform duration-200 ease-out group-hover:scale-[1.04]" data-id="element-144" data-mp="350slhson96qu" />
        </div>
        <div className="px-1 pb-1 pt-3" data-id="element-145" data-mp="3npz8vt0dumiz">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-gold-300" data-id="element-146" data-mp="3noxouz1e2pp4">Bono {b.number}</p>
          <h3 className="mt-0.5 font-serif text-lg leading-tight text-cream sm:text-xl" data-id="element-147" data-mp="3sqwru7t7vklj">{b.title}</h3>
          <p className="mt-1 text-[13px] leading-snug text-petrol-100" data-id="element-148" data-mp="1jagdt09adu4">{b.description}</p>
        </div>
      </div>
    </li>;
}